module.exports = __webpack_public_path__ + "static/media/eee_dirgha.a57ebce6.ogg";